import { useMemo } from "react";
import { SettingsService } from "@/services/SettingsService";
import { useQuery } from "@tanstack/react-query";

/**
 * Hook to fetch maintenance status (authenticated users)
 * Uses a short stale time and regular refetch for responsiveness
 */
export function useMaintenanceStatus() {
  const settingsService = useMemo(() => new SettingsService(), []);

  return useQuery({
    queryKey: ["maintenanceStatus"],
    queryFn: () => settingsService.getMaintenanceStatus(),
    staleTime: 30 * 1000, // 30 seconds
    refetchInterval: 60 * 1000, // Refetch every 60 seconds
    refetchOnWindowFocus: true,
    retry: 1,
  });
}
